import { blockCategories } from '../categories';

const COMPONENT_TYPE = 'teaser-journey-field-select';
const FIELD_TYPES = {
    category: {
        componentType: 'teaser-journey-category-select',
        label: 'Journey Category Select',
        blockLabel: 'Kategorien',
        cssClass: 'sio-teaser-category-select',
        fieldLabel: 'Kategorien',
    },
    country: {
        componentType: 'teaser-journey-country-select',
        label: 'Journey Country Select',
        blockLabel: 'Länder',
        cssClass: 'sio-teaser-country-select',
        fieldLabel: 'Länder',
    },
    level: {
        componentType: 'teaser-level',
        label: 'Journey Level',
        blockLabel: 'Level',
        cssClass: 'sio-teaser-level',
        fieldLabel: 'Level',
    },
};

const DEFAULT_TYPE = 'category';
const ALL_CSS_CLASSES = Object.values(FIELD_TYPES).map((f) => f.cssClass);
const componentTypeToKey = Object.entries(FIELD_TYPES).reduce(
    (acc, [key, cfg]) => ({ ...acc, [cfg.componentType]: key }),
    {}
);

export default function teaserFieldSelect(
    editor,
    {
        category = blockCategories.teaser,
        defaultMaxItems = null,
        sepratorField = '',
    } = {}
) {
    editor.DomComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            const siotype = el.getAttribute?.('data-siotype');
            if (siotype === COMPONENT_TYPE) {
                return { type: COMPONENT_TYPE };
            }
            const key = componentTypeToKey[siotype];
            if (key) {
                return { type: COMPONENT_TYPE, fieldType: key };
            }
            return false;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: FIELD_TYPES[DEFAULT_TYPE].label,
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                content: sepratorField,
                fieldType: DEFAULT_TYPE,

                attributes: {
                    class: FIELD_TYPES[DEFAULT_TYPE].cssClass,
                    'data-siotype': FIELD_TYPES[DEFAULT_TYPE].componentType,
                    'data-field-type': DEFAULT_TYPE,
                    'data-field-label': FIELD_TYPES[DEFAULT_TYPE].fieldLabel,
                    'data-max-items': defaultMaxItems,
                    'data-seprator-field': sepratorField,
                },

                components: [],

                traits: [
                    {
                        type: 'select',
                        name: 'fieldType',
                        label: 'Feld-Typ',
                        value: DEFAULT_TYPE,
                        options: Object.entries(FIELD_TYPES).map(([id, cfg]) => ({
                            id,
                            name: cfg.blockLabel,
                        })),
                    },
                    {
                        type: 'number',
                        name: 'maxItems',
                        label: 'Maximale Anzahl',
                        step: 1,
                        value: defaultMaxItems,
                    },
                    {
                        type: 'custom-textarea',
                        name: 'content',
                        label: 'Trennzeichen',
                        placeholder: 'Text, HTML, SVG, etc.',
                        value: sepratorField,
                        attributes: {
                            rows: 4,
                            class: 'separator-content-textarea',
                        },
                    },
                ],
            },

            init() {
                const traits = this.get('traits');
                if (!traits) return;

                const fieldTypeTrait = traits.get('fieldType');
                if (fieldTypeTrait) {
                    this.listenTo(
                        fieldTypeTrait,
                        'change:value',
                        this.handleFieldTypeChange
                    );
                }

                const contentTrait = traits.get('content');
                if (contentTrait) {
                    this.listenTo(
                        contentTrait,
                        'change:value',
                        this.handleContentChange
                    );
                }

                const maxItemsTrait = traits.get('maxItems');
                if (maxItemsTrait) {
                    this.listenTo(
                        maxItemsTrait,
                        'change:value',
                        this.handleMaxItemsChange
                    );
                }
                this.handleFieldTypeChange();
            },

            handleFieldTypeChange() {
                const fieldTypeTrait = this.get('traits')?.get('fieldType');
                const type =
                    fieldTypeTrait?.get('value') || this.get('fieldType') || DEFAULT_TYPE;
                const cfg = FIELD_TYPES[type] || FIELD_TYPES[DEFAULT_TYPE];

                const currentClasses = (this.getAttributes().class || '')
                    .split(' ')
                    .filter((c) => c && !ALL_CSS_CLASSES.includes(c));
                currentClasses.push(cfg.cssClass);

                this.addAttributes({
                    class: currentClasses.join(' '),
                    'data-siotype': cfg.componentType,
                    'data-field-type': type,
                    'data-field-label': cfg.fieldLabel,
                });

                this.set('fieldType', type);
                this.set('name', cfg.label);
            },

            handleContentChange() {
                const contentTrait = this.get('traits')?.get('content');
                if (!contentTrait) return;
                const content = contentTrait.get('value') || '';
                this.addAttributes({ 'data-seprator-field': content });
            },

            handleMaxItemsChange() {
                const maxItems = this.get('traits')?.get('maxItems')?.get('value');
                this.addAttributes({ 'data-max-items': maxItems });
            },
        },

        view: {},
    });
    Object.entries(FIELD_TYPES).forEach(([key, cfg]) => {
        editor.BlockManager.add(`${cfg.componentType}-block`, {
            label: cfg.blockLabel,
            category,
            media: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 19h18"/><path d="M15 12H3"/><path d="M9 5H3"/></svg>`,
            content: {
                type: COMPONENT_TYPE,
                fieldType: key,
                attributes: {
                    class: cfg.cssClass,
                    'data-siotype': cfg.componentType,
                    'data-field-type': key,
                    'data-field-label': cfg.fieldLabel,
                    'data-max-items': defaultMaxItems,
                    'data-seprator-field': sepratorField,
                },
            },
        });
    });
}
